/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import {StepperComponent} from '../../../../../_metronic/assets/ts/components'
import {useToast} from '../../../components/Toats'
import {LoadingSpan} from '../../../components/Loadings/loadingSpan'
import {deleteInvoice} from '../../../../services/invoices'

type Props = {
  id: string
  data: any
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalDeleteInvoice = ({show, handleClose, id, data}: Props) => {
  const {toggleToast} = useToast()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const invoiceLabel =
    data?.unitConsumer?.name || data?.unitConsumer?.contrato || 'Não identificado'

  const deleteInvoiceSubmit = async () => {
    try {
      setLoading(true)
      await deleteInvoice(id)
      toggleToast('Sucesso ao deletar a fatura. ', 'success')
    } catch (error: any) {
      console.log('erro', error)
      toggleToast(error?.response?.data?.message || 'Erro ao deletar a fatura. ', 'error')
    } finally {
      setLoading(false)
      closed()
    }
  }

  const submit = () => {
    deleteInvoiceSubmit()
  }

  return createPortal(
    <Modal
      id='kt_modal_delete_invoice'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Deletar Fatura {' - '}{invoiceLabel}</span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        <div ref={stepperRef}>
          <div style={{marginBottom: '3rem'}}>
            <h3 className='card-title align-items-start flex-column'>
              <span className='text-muted mt-1 fw-semibold fs-5'>
                Deseja deletar essa fatura permanentemente?
              </span>
            </h3>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <button
              type='button'
              className='btn btn-lg btn-light'
              disabled={loading}
              onClick={() => {
                closed()
              }}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-3 ms-2 me-0' />
              <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
            </button>

            <button
              type='button'
              className='btn btn-lg btn-danger'
              disabled={loading}
              onClick={submit}
            >
              Deletar
              {loading ? (
                <LoadingSpan style={{marginLeft: '0.5rem'}} />
              ) : (
                <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-3 ms-2 me-0' />
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalDeleteInvoice}
